import { Footer, HeadlineWithSpacing, tokens, TOOLBAR_HEIGHT } from 'ComponentLibrary'
import PageColumn from '../PageColumnTemplate/PageColumnTemplate'
import { HeadlineWithSpacingProps } from 'ComponentLibrary/src/molecules/HeadlineWithSpacing/HeadlineWithSpacing'
import { Box, Stack, styled } from '@mui/material'
import { ReactNode } from 'react'

type PageTemplateProps = {
    children: ReactNode
    fullWidth?: boolean
    headline?: HeadlineWithSpacingProps
    withMargin?: boolean
    withBottomSpace?: boolean
    alignLeft?: boolean
    pageTopAdornment?: ReactNode
    withMaxWidth?: boolean
    withFooter?: boolean
    withBackground?: boolean
}

export const LEFT_ALIGNMENT = '6vw'
export const EXTRA_BOTTOM_SPACE = '120px'

export default function PageTemplate({
    children,
    fullWidth = false,
    headline,
    withMargin,
    withBottomSpace,
    alignLeft,
    pageTopAdornment,
    withMaxWidth,
    withFooter,
    withBackground,
}: PageTemplateProps) {
    return (
        <Box
            sx={{
                background: withBackground
                    ? `linear-gradient(${tokens.ColorSurfaceAccentRoyalDefault} 250px, transparent 250px)`
                    : undefined,
            }}
            width="100%"
        >
            <Wrapper $withMargin={withMargin} $alignLeft={alignLeft} $fullWidth={fullWidth} $withMaxWidth={withMaxWidth}>
                <Stack direction="column" minHeight={`calc(100vh - ${TOOLBAR_HEIGHT} - ${EXTRA_BOTTOM_SPACE} - 1px)`}>
                    {pageTopAdornment && <Box marginTop={tokens.SizingSpacing200}>{pageTopAdornment}</Box>}
                    <PageColumn fullWidth={fullWidth} maxColumnWidth={!fullWidth}>
                        {headline && (
                            <HeadlineWithSpacing
                                title={headline.title}
                                subtitle={headline.subtitle}
                                locked={headline.locked}
                                setLocked={headline.setLocked}
                                onClickAddItem={headline.onClickAddItem}
                                endAdornment={headline.endAdornment}
                                endAdornmentStyle={headline.endAdornmentStyle}
                                options={headline.options}
                                isPersisting={headline.isPersisting}
                                variant={headline.variant ? headline.variant : 'headline1'}
                                optionsIcon={headline.optionsIcon}
                                actions={headline.actions}
                                isAddDisabled={headline.isAddDisabled}
                            />
                        )}
                        {children}
                    </PageColumn>
                </Stack>
                <Stack direction="row" height={withBottomSpace ? EXTRA_BOTTOM_SPACE : undefined} alignItems="flex-end">
                    {withFooter && <Footer />}
                </Stack>
            </Wrapper>
        </Box>
    )
}

const Wrapper = styled('div', { shouldForwardProp: (prop: string) => prop[0] !== '$' })<{
    $withMargin?: boolean
    $alignLeft?: boolean
    $fullWidth?: boolean
    $withMaxWidth?: boolean
}>(({ theme, $withMargin, $alignLeft, $fullWidth, $withMaxWidth }) => {
    const numberOfPaddings = $withMargin ? 3 : 1
    // Before we fix the resizing issue we add spacing to avoid covering things up with the sidebar
    return {
        margin: $alignLeft ? `0 ${LEFT_ALIGNMENT}` : '0 auto',
        width: $fullWidth ? ($alignLeft ? `calc(100% - 2 * ${LEFT_ALIGNMENT})` : '100%') : undefined,
        maxWidth: $withMargin || $withMaxWidth ? `calc((580px * 2) + ${numberOfPaddings} * 48px)` : undefined,
        paddingLeft: $withMargin ? theme.spacing(12) : undefined,
        paddingRight: $withMargin ? theme.spacing(12) : undefined,
        boxSizing: 'border-box',
    }
})
